<script setup>
import { Dashboard } from '@uppy/vue';
import AwsS3 from '@uppy/aws-s3';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import Uppy from '@uppy/core';
import { ApiWrapper } from "@/Utils/ApiWrapper";
import { activeComponentStore } from "@/Stores/ActiveComponentStore";
import { ToastUtil } from "@/Utils/ToastUtil";
import { onMounted, onUnmounted, shallowRef } from "vue";

const props = defineProps({
  myProfile: Boolean,
  personId: String,
  claimId: String
});

const uppy = shallowRef(null);

onMounted(() => {
  uppy.value = new Uppy().use(AwsS3, {
    shouldUseMultipart: false,
    limit: 1,
    getUploadParameters: async (file) => {
      return new Promise((resolve, reject) => {
        ApiWrapper.post("files", "get-upload-url", {
          filename: file.name,
          contentType: file.type,
          myProfile: props.myProfile,
          personId: props.personId,
          claimId: props.claimId
        })
            .then((response) => {
              resolve({
                method: "put",
                url: response.url,
                fields: {},
                headers: {
                  "Content-Type": file.type,
                },
              });
            })
            .catch((e) => {
              reject(e);
              ToastUtil.error(e);
            });
      });
    },
  });

  uppy.value.on("complete", () => {
    ToastUtil.successMsg('Successfully uploaded!');
    setTimeout(() => {
      activeComponentStore.notifyComponents(['files'], 'FilesUploadComponent');
    }, 2500);
    uppy.value.clear();
  });
});

onUnmounted(() => {
  uppy.value?.destroy();
});

const dashOptions = {
  inline: true,
  height: 350,
  width: '100%',
  proudlyDisplayPoweredByUppy: false,
};
</script>

<template>
  <v-container fluid>
    <v-card>
      <Dashboard v-if="uppy" :uppy="uppy" :inline="true" :props="dashOptions" />
    </v-card>
  </v-container>
</template>